export default __webpack_public_path__ + "static/emoji-blurred-fabdb0c661eace42864eecbc7553f5fc.svg";